var staticHGKeyRE = /(.+)?\[(\d+)\]$/

module.exports = staticHGKeyRE



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticHGKeyRE.js
// module id = 451
// module chunks = 75